// src/components/Navbar.js
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="navbar-logo">
          <Link to="/">
            <img src="/assets/main-logo.png" alt="GoKwik Media" />
          </Link>
        </div>

        {/* Hamburger Menu Button */}
        <div className={`hamburger ${mobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className="navbar-menu">
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? "active" : "")}
            end
          >
            Home
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            About Us
          </NavLink>

          <NavLink
            to="/services"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Blog
          </NavLink>

          <NavLink
            to="/blog"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Services
          </NavLink>

          {/* ================================
            🔻 Dropdown: Pricing & Plan
        ================================= */}
          <div className="dropdown">
            <span className="dropdown-title">Pricing & Plan</span>

            <div className="dropdown-menu">
              <Link to="/contact#contactForm">
                Website Design & Development{" "}
              </Link>
              <Link to="/dmp">Digital Marketing Packages</Link>
              <Link to="/google">Google Online Ads</Link>
              <Link to="/social">Social Media Ads (Facebook/Instagram)</Link>
              <Link to="/smm">Social Media Management (SMM)</Link>
              <Link to="/price">Search Engine Optimization (SEO)</Link>
            </div>
          </div>

          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Contact Us
          </NavLink>
        </nav>

        <div className="whatsapp1">
          <a
            href="https://api.whatsapp.com/send/?phone=919624883636&text=Hi&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-icon"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
            />
          </a>

          <div className="navbar-actions">
            <Link to="/contact" onClick={closeMobileMenu}>
              <button className="navbar-button">Get In Touch</button>
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu">
          <Link to="/" onClick={closeMobileMenu} className={({ isActive }) => (isActive ? "active" : "")} end>
            Home
          </Link>

          <Link to="/about" onClick={closeMobileMenu} className={({ isActive }) => (isActive ? "active" : "")}>
            About Us
          </Link>

          <Link to="/services" onClick={closeMobileMenu} className={({ isActive }) => (isActive ? "active" : "")}>
            Blog
          </Link>

          <Link to="/blog" onClick={closeMobileMenu} className={({ isActive }) => (isActive ? "active" : "")}>
            Services
          </Link>

          {/* Mobile Dropdown */}
          <div className={`mobile-dropdown ${dropdownOpen ? 'active' : ''}`}>
            <div className="mobile-dropdown-title" onClick={toggleDropdown}>
              Pricing & Plan
            </div>
            <div className="mobile-dropdown-menu">
              <Link to="/contact#contactForm" onClick={closeMobileMenu}>
                Website Design & Development
              </Link>
              <Link to="/google" onClick={closeMobileMenu}>Google Online Ads</Link>
              <Link to="/social" onClick={closeMobileMenu}>Social Media Ads (Facebook/Instagram)</Link>
              <Link to="/dmp" conClick={closeMobileMenu}>Digital Marketing Packages</Link>
              <Link to="/smm" onClick={closeMobileMenu}>Social Media Management (SMM)</Link>
              <Link to="/price" onClick={closeMobileMenu}>Search Engine Optimization (SEO)</Link>
            </div>
          </div>

          <Link to="/contact" onClick={closeMobileMenu} className={({ isActive }) => (isActive ? "active" : "")}>
            Contact Us
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Navbar;

